import { ImagePlus } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";

const Option = ({ n, f, setF }) => {
  const on = f[`bonus_claim${n}_on`];
  return (
    <div className="space-y-2">
      <label className="flex items-center gap-3 cursor-pointer">
        <Checkbox data-testid={`drop-bonus-claim${n}-checkbox`} checked={on} onCheckedChange={(c) => setF({ ...f, [`bonus_claim${n}_on`]: !!c })} />
        <span className="text-sm font-medium">Claim {n}</span>
      </label>
      {on && (
        <Input data-testid={`drop-bonus-claim${n}-input`} value={f[`bonus_claim${n}`]} maxLength={300} placeholder={`Bonus for claiming ${n}`}
          onChange={(e) => setF({ ...f, [`bonus_claim${n}`]: e.target.value })} className="bg-zinc-900" />
      )}
    </div>
  );
};

const BonusImage = ({ src, onFile }) => (
  <div className="space-y-1.5">
    <div className="text-sm font-medium">Bonus Preview Image</div>
    <label className="relative flex items-center justify-center rounded-xl border-2 border-dashed border-zinc-700 hover:border-amber-400/60 transition-colors cursor-pointer h-36 overflow-hidden bg-zinc-900">
      <input type="file" accept="image/*" className="hidden" data-testid="drop-bonus-preview-input" onChange={(e) => onFile(e.target.files?.[0] || null)} />
      {src ? (
        <img src={src} alt="Bonus preview" data-testid="drop-bonus-preview-image" className="absolute inset-0 h-full w-full object-contain" />
      ) : (
        <span className="text-center text-sm text-zinc-400"><ImagePlus className="h-6 w-6 mx-auto mb-1 text-zinc-500" />Upload bonus preview</span>
      )}
    </label>
  </div>
);

export const BonusItemsFields = ({ f, setF, imageSrc, onImage }) => (
  <div className="rounded-xl border border-white/10 bg-zinc-900/40 p-4 space-y-3" data-testid="drop-bonus-fields">
    <label className="flex items-center gap-3 cursor-pointer">
      <Checkbox data-testid="drop-bonus-items-checkbox" checked={f.bonus_items} onCheckedChange={(c) => setF({ ...f, bonus_items: !!c })} />
      <span>
        <span className="block text-sm font-medium">Bonus Items</span>
        <span className="block text-xs text-zinc-500">Shown on the drop page under Additional Information</span>
      </span>
    </label>
    {f.bonus_items && (
      <div className="pl-7 space-y-3">
        <Option n={3} f={f} setF={setF} />
        <Option n={8} f={f} setF={setF} />
        <BonusImage src={imageSrc} onFile={onImage} />
      </div>
    )}
  </div>
);

export const bonusInitial = (drop) => ({
  bonus_items: !!drop.bonus_items,
  bonus_claim3_on: !!drop.bonus_claim3,
  bonus_claim3: drop.bonus_claim3 || "",
  bonus_claim8_on: !!drop.bonus_claim8,
  bonus_claim8: drop.bonus_claim8 || "",
});

export const bonusPayload = ({ bonus_claim3_on, bonus_claim8_on, ...f }) => ({
  ...f,
  bonus_claim3: f.bonus_items && bonus_claim3_on ? f.bonus_claim3 : "",
  bonus_claim8: f.bonus_items && bonus_claim8_on ? f.bonus_claim8 : "",
});
